module.exports = __webpack_public_path__ + "static/media/30OIOS8.4e7cbf7d.jpg";